import { useQuery } from '@tanstack/react-query';
import { subscriptionService } from '../../../services/subscription';
import { useAppSelector } from '@redux/hooks';
import { RootState } from '@redux/store';

/**
 * Keyed by the current organization even when no id is passed.
 *
 * The request is scoped by the `X-Organization-ID` header, so without the id in the
 * key every organization shared one cache entry and the page showed the previously
 * opened organization's numbers for the whole staleTime. Same fix as useSubscription.
 */
export const useTotalIncludedSeats = () => {
  const organizationId = useAppSelector(
    (state: RootState) => state.organization.organizationId,
  );

  return useQuery<number>({
    queryKey: ['totalIncludedSeats', organizationId],
    queryFn: () => subscriptionService.getTotalIncludedSeats(),
    enabled: !!organizationId,
  });
};
